import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "mx-5" }, "Слепая печать", -1)
const _hoisted_2 = {
  key: 0,
  class: "input-group flex-column mb-3"
}
const _hoisted_3 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  disabled: "",
  value: "default"
}, "Выберите язык:", -1)
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_7 = {
  key: 1,
  class: "input-group flex-column mb-3"
}
const _hoisted_8 = {
  for: "sentences",
  class: "form-label align-self-start"
}
const _hoisted_9 = ["id", "onUpdate:modelValue", "placeholder", "onBlur"]
const _hoisted_10 = {
  key: 0,
  class: "invalid-feedback"
}

import {ref} from "vue";

import useVuelidate from "@vuelidate/core";
import {formSchemaType} from '@/components/formConstruct/formConstructor'


export default /*#__PURE__*/_defineComponent({
  __name: 'formConstruct',
  props: {
    formSchema: {},
    formValidation: {}
  },
  emits: ["sendData"],
  setup(__props: any, { emit }) {

const props = __props;






let formData: any = ref({})

props.formSchema.forEach((item) => {
  formData.value[item.name] = item.default
})

let $v = useVuelidate(props.formValidation, formData)

function sendData() {
  $v.value.$touch()
  if ($v.value.$errors.length) return
  emit('sendData', formData.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", null, [
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formSchema, (element) => {
      return (_openBlock(), _createElementBlock("div", {
        key: element.name
      }, [
        (element.type === 'select')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": ($event: any) => ((_unref(formData)[element.name]) = $event),
                class: _normalizeClass(["form-select w-100", {'is-invalid': _unref($v)[element.name].$error}]),
                onBlur: ($event: any) => (_unref($v)[element.name].$touch())
              }, [
                _hoisted_4,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.options.selectData, ({label,value}) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: label,
                    value: value
                  }, _toDisplayString(label), 9, _hoisted_5))
                }), 128))
              ], 42, _hoisted_3), [
                [_vModelSelect, _unref(formData)[element.name]]
              ]),
              (_unref($v)[element.name].$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref($v)[element.name].$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid
                      }, _toDisplayString(error.$message), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (element.type === 'input')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(element.label), 1),
              _withDirectives(_createElementVNode("input", {
                id: element.name,
                "onUpdate:modelValue": ($event: any) => ((_unref(formData)[element.name]) = $event),
                class: _normalizeClass(["form-control w-100", {'is-invalid': _unref($v)[element.name].$error}]),
                placeholder: element.placeholder || 'Заполните поле',
                onBlur: ($event: any) => (_unref($v)[element.name].$touch())
              }, null, 42, _hoisted_9), [
                [_vModelText, _unref(formData)[element.name]]
              ]),
              (_unref($v)[element.name].$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref($v)[element.name].$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid
                      }, _toDisplayString(error.$message), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createElementVNode("div", { class: "mb-3" }, [
      _createElementVNode("button", {
        class: "btn btn-primary",
        type: "button",
        onClick: sendData
      }, " Выбрать ")
    ])
  ]))
}
}

})